import legalFooterStyles from './legal-footer';
import PseudoDropdownStyles from '../pseudo-dropdown/pseudo-dropdown';
import PseudoDropdown from '../pseudo-dropdown';

export default class LegalFooter {
  constructor() {
    this.setDefaults();
    if(this.legalFooterDropdowns) {
      this.setUpPseudoDropdown();
    }
  }

  setDefaults() {
    this.pseudoDropdowns = [];
    this.legalFooterDropdowns = document.querySelectorAll('.legal-footer .pseudo-dropdown');
  }

  setUpPseudoDropdown() {
    [...this.legalFooterDropdowns].map( (legalFooterDropdown, index) => {
      this.pseudoDropdowns[index] = new PseudoDropdown(legalFooterDropdown, true, false);
    })
  }
}
